<template>
    <div class="bg-white p-6 shadow-md rounded-lg">
        <h2 class="text-lg font-semibold text-gray-700 mb-4 flex items-center">
            <font-awesome-icon :icon="['fas', 'user-graduate']" class="text-blue-600 mr-2" />
            Admission Types
        </h2>
        <div v-if="hasData">
            <apexchart type="pie" height="300" :options="chartOptions" :series="chartSeries" />
        </div>
        <div v-else class="text-gray-500 text-center py-16">
            <div class="text-4xl mb-2">📊</div>
            <div>There is no data to show</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AdmissionTypeChart",
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        hasData() {
            return this.data && this.data.length > 0;
        },
        chartSeries() {
            return this.data.map(item => item.count);
        },
        chartOptions() {
            const labels = this.data.map(item => this.formatAdmissionType(item.admission_type));
            const colors = this.getAdmissionTypeColors(labels);

            return {
                labels: labels,
                colors: colors,
                legend: {
                    position: 'bottom',
                    formatter: (seriesName, opts) => {
                        const seriesIndex = opts.seriesIndex;
                        const value = this.chartSeries[seriesIndex];
                        return `${seriesName} - ${value}`;
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val.toFixed(1) + '%';
                    },
                },
                tooltip: {
                    y: {
                        formatter: (val) => `${val} Applications`,
                    },
                },
                chart: {
                    type: 'pie',
                }
            };
        }
    },
    methods: {
        formatAdmissionType(type) {
            const typeMap = {
                'Direct Entry': 'Direct Entry',
                'Conditional Entry': 'Conditional Entry',
                'Appeal': 'Appeal'
            };
            return typeMap[type] || type;
        },
        getAdmissionTypeColors(labels) {
            const colorMap = {
                'Direct Entry': '#3498DB',
                'Conditional Entry': '#E74C3C',
                'Appeal': '#F39C12'
            };

            return labels.map(label => colorMap[label] || '#95A5A6');
        }
    }
};
</script>